import React from 'react';
import './Sec4TestiDevelop.css';
import Testi from './Testi.js';
import Develop from './Develop.js';

const Sec4TestiDevelop = () => {
    return (
        <div className="container_third">
            <Testi />
            <Develop />
        </div>
        
    )
}

export default Sec4TestiDevelop;